import type { IUIState, UIActions } from './UIContext';
import { UIActionTypes } from './UIContext';

export const UIReducer = (state: IUIState, action: UIActions) => {
  switch (action.type) {
    case UIActionTypes.MODEL_IS_MODIFIED:
      return {
        ...state,
        modelIsModified: action.payload
      };
    case UIActionTypes.SET_PANEL_TOP:
      return {
        ...state,
        panelTop: action.payload
      };
    case UIActionTypes.SET_CURRENT_ENVIRONMENT:
      return {
        ...state,
        currentEnvironment: action.payload
      };
    case UIActionTypes.CLEAR_CURRENT_ENVIRONMENT:
      return {
        ...state,
        currentEnvironment: undefined
      };
    default:
      return state;
  }
};
